'use strict';
namespace TR {
    class NewHomeRecommenders {
        recommendationLength: number = 3;
        recommendations: any = new Array(this.recommendationLength).fill({ ImageUrl: '' });

        constructor(
            private $location: ng.ILocationService,
            private $scope: ng.IScope,
            private $rootScope: ng.IRootScopeService,
            private broker: Core.Broker,
            private savedSearchService: any,
            private basketService: any,
            private occupancyService: Core.OccupancyService,
            private destinationService: any,
            private searchTypesService: any,
            private analytics: any,
            private resourceService: any,
            private recommender: any,
            private recommenderUiHelper: any
        ) {
            this.initSlider();
            this.initSubscriptions();
        }

        $onDestroy() {
            this.broker.unsubscribe('newHomeRecommenders', 'savedSearchRemoved');
        }

        async initSlider(): Promise<any> {
            const { Hotels, Holidays } = this.searchTypesService.searchType;
            const allSearches: any = await this.savedSearchService.getSavedSearches();
            const filteredSearches = allSearches.filter(
                ({ SearchType }) => SearchType === Hotels || SearchType === Holidays
            );
            let Destination: any = null;
            const filteredSearchesExist = filteredSearches.length > 0;
            if(filteredSearchesExist) {
                const [ search ] = filteredSearches;
                Destination = search.Destination;
                const { Rooms } = search;
                const [ Duration, Dates ] = search.Duration.split(', ');
                this.recommendations[0] = {
                    ...search,
                    Title: Destination.Title,
                    Duration,
                    Dates,
                    Occupancy: this.occupancyService.getOccupancyString(Rooms),
                    ImageUrl: this.destinationService.destinationThumb(Destination),
                    isPreviousSearch: true,
                    ngClick: this.ngClickSearch(search)
                };
            }
            const options = { imgWidth: this.$scope.imgWidth };
            const {
                destinations,
                trackClick,
                trackView
            } = await this.recommender.getDestinationsForLanding('HomePageNewRecommender', options, Destination);
            this.recommendations = this.recommendations.map((recommendation, index) => {
                if(filteredSearchesExist && (index === 0)) {
                    return {
                        ...recommendation,
                        ngClick: this.ngClickSearch(recommendation)
                    };
                } else {
                    const filteredSearchIndex = filteredSearchesExist ? index - 1 : index;
                    const similarDestination = destinations[filteredSearchIndex];
                    return {
                        ...similarDestination,
                        isRecommended: true,
                        ngClick: this.ngClickDestination(similarDestination, trackClick, trackView)
                    };
                }
            }).slice(0, this.recommendationLength);
            this.$scope.$apply();
        }

        initRecommender() {
            this.recommendations = new Array(this.recommendationLength).fill({ ImageUrl: '' });
            this.initSlider();
        }

        initSubscriptions() {
            this.broker.subscribe('newHomeRecommenders', 'savedSearchRemoved', () => this.initRecommender());
            this.$rootScope.$on('auth:signout', () => this.initRecommender());
            this.$rootScope.$on('auth:signin', () => this.initRecommender());
        }

        ngClickSearch(search) {
            const { SearchType } = search;
            const { Hotels, Holidays } = this.searchTypesService.searchType;
            const { title, loadingScreenStyle } = {
                [Hotels]: {
                    title: this.resourceService.get('SEARCHINGHOTELS'),
                    loadingScreenStyle: 'hotels-newHomeRecommendersHotel-select'
                },
                [Holidays]: {
                    title: this.resourceService.get('SEARCHINGFLIGHTSANDHOTELS'),
                    loadingScreenStyle: 'hotels-newHomeRecommendersHolidays-select'
                }
            }[SearchType];
            const subtitle = this.resourceService.get('THISMAYTAKE');
            return async (ev): Promise<any> => {
                ev.preventDefault();
                ev.stopPropagation();
                this.$scope.$emit('block', {
                    title,
                    subtitle,
                    loadingScreenStyle
                });
                this.analytics.trackEvent({ label: 'restore saved search' });
                await this.savedSearchService.restoreSearch(search);
                await this.basketService.startWorkflow(this.basketService.workflowType[SearchType]);
            };
        }

        ngClickDestination(destination, trackClick, trackView) {
            return async (ev): Promise<any> => {
                ev.preventDefault();
                ev.stopPropagation();
                const { PagePath } = await this.destinationService.getDetails(destination);
                trackClick(destination, this.recommenderUiHelper.getPageSize());
                this.$location.path(PagePath);
            };
        }
    }

    angular.module('TR')
        .component('newHomeRecommenders', {
            bindings: {
                imgWidth: '@'
            },
            controller: NewHomeRecommenders,
            controllerAs: 'nhr',
            templateUrl: 'partials/home/directivetemplate?type=NewHomeRecommenders'
        });
}
